import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import intl from 'i18n/intl';
import { EReservationStatuses } from '@timeedit/types/enums';
import { Alert } from '@timeedit/ui-components';
import { Checkbox, Col, Row, Typography } from '@timeedit/ui-components/antd';
import { AllocateSettingsSelector } from '../../../../slices/appsAllocateSettings';

const language = intl.messages as Record<string, string>;

type ReservationStatusProps = {
  status: string[];
  setStatus: React.Dispatch<React.SetStateAction<string[]>>;
};
export function ReservationStatus({
  status,
  setStatus,
}: ReservationStatusProps) {
  const settings = useSelector(AllocateSettingsSelector);

  useEffect(() => {
    setStatus((prevStatus) => {
      if (prevStatus.length === 0 && settings.reservationStatuses) {
        return settings.reservationStatuses;
      }
      return prevStatus;
    });
  }, [settings.reservationStatuses]);

  const options = Object.keys(EReservationStatuses).map((key) => {
    return (
      <Col key={key} span={12}>
        <Checkbox
          value={EReservationStatuses[key as keyof typeof EReservationStatuses]}
        >
          {key}
        </Checkbox>
      </Col>
    );
  });

  return (
    <div>
      <Typography.Title level={4}>
        {
          language[
            'integration.calendar.sync_settings.form.reservation_status.label'
          ]
        }
      </Typography.Title>
      <div className="reservation-status__container">
        <Checkbox.Group value={status} onChange={setStatus}>
          <Row gutter={0}>{options}</Row>
        </Checkbox.Group>
      </div>
      <br />
      <Alert
        className="help-text"
        description={language.allocateFilterReservationStatusHelp}
        type="info"
        showIcon={false}
      />
    </div>
  );
}
